(function () {
  var FAV_KEY = 'def_product_wishlist';
  var LEGACY_KEY = 'def_product_favourites';
  var CARD_SECTION = 'wishlist-product-card';

  function getStoreRoot() {
    if (window.DEFWishlistConfig && window.DEFWishlistConfig.root) {
      return window.DEFWishlistConfig.root;
    }
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return '/';
  }

  function normalizeHandle(value) {
    if (!value || typeof value !== 'string') return '';
    var handle = value.trim().toLowerCase();
    if (!handle || /^\d+$/.test(handle)) return '';
    return handle;
  }

  function getFavs() {
    try {
      var list = JSON.parse(localStorage.getItem(FAV_KEY) || '[]');
      if (!Array.isArray(list)) return [];
      var seen = {};
      var result = [];
      list.forEach(function (item) {
        var handle = normalizeHandle(item);
        if (handle && !seen[handle]) {
          seen[handle] = true;
          result.push(handle);
        }
      });
      return result;
    } catch (e) {
      return [];
    }
  }

  function setFavs(list) {
    try {
      var seen = {};
      var normalized = [];
      list.forEach(function (item) {
        var handle = normalizeHandle(item);
        if (handle && !seen[handle]) {
          seen[handle] = true;
          normalized.push(handle);
        }
      });
      localStorage.setItem(FAV_KEY, JSON.stringify(normalized));
      return normalized;
    } catch (e) {
      return list;
    }
  }

  function migrateLegacyFavs() {
    try {
      var legacy = JSON.parse(localStorage.getItem(LEGACY_KEY) || '[]');
      if (!Array.isArray(legacy) || !legacy.length) return;
      localStorage.removeItem(LEGACY_KEY);
    } catch (e) {}
  }

  function getHandleFromUrl(url) {
    if (!url) return '';
    var match = String(url).match(/\/products\/([^/?#]+)/i);
    return match ? normalizeHandle(match[1]) : '';
  }

  function getBtnHandle(btn) {
    if (!btn) return '';

    var handle = normalizeHandle(btn.dataset.favHandle || '');
    if (handle) return handle;

    var productRoot = btn.closest('[data-product-handle]');
    if (productRoot) {
      handle = normalizeHandle(productRoot.dataset.productHandle || '');
      if (handle) return handle;
    }

    var productInfo = btn.closest('product-info');
    if (productInfo) {
      handle = getHandleFromUrl(productInfo.dataset.url);
      if (handle) return handle;
    }

    var card = btn.closest('.brand-product-card');
    if (card) {
      var cardLink = card.querySelector('.brand-product-card__link[href*="/products/"]');
      handle = getHandleFromUrl(cardLink && cardLink.getAttribute('href'));
      if (handle) return handle;
    }

    return '';
  }

  function applyFavState(btn) {
    var handle = getBtnHandle(btn);
    if (!handle) return;

    var favs = getFavs();
    var label = btn.getAttribute('aria-label') || '';
    var isFav = favs.indexOf(handle) !== -1;

    btn.classList.toggle('is-fav', isFav);
    btn.setAttribute('aria-pressed', isFav ? 'true' : 'false');

    if (isFav && label.indexOf('Add ') === 0) {
      btn.setAttribute('aria-label', label.replace('Add ', 'Remove '));
    } else if (!isFav && label.indexOf('Remove ') === 0) {
      btn.setAttribute('aria-label', label.replace('Remove ', 'Add '));
    }
  }

  function syncAllButtons(handle) {
    if (!handle) return;
    document.querySelectorAll('.brand-product-card__fav, .product-form__wishlist, .product-form__wishlist-btn').forEach(function (btn) {
      if (getBtnHandle(btn) === handle) {
        applyFavState(btn);
      }
    });
  }

  function updateHeaderCount() {
    var count = getFavs().length;
    document.querySelectorAll('.js-wishlist-count, .header__wishlist-count').forEach(function (el) {
      el.textContent = String(count);
      el.classList.toggle('is-empty', count === 0);
      el.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
    });
  }

  function removeWishlistItem(handle, sourceEl) {
    handle = normalizeHandle(handle);
    if (!handle) return false;

    var favs = getFavs();
    var idx = favs.indexOf(handle);
    if (idx === -1) return false;

    favs.splice(idx, 1);
    favs = setFavs(favs);
    syncAllButtons(handle);
    updateHeaderCount();

    if (sourceEl) {
      var row = sourceEl.closest('[data-wishlist-item]');
      if (row) row.remove();
    }

    var page = document.querySelector('[data-wishlist-page]');
    if (page) {
      var grid = page.querySelector('[data-wishlist-grid]');
      var empty = page.querySelector('[data-wishlist-empty]');
      if (grid && !grid.querySelector('[data-wishlist-item]')) {
        if (empty) empty.hidden = false;
      }
    }

    document.dispatchEvent(new CustomEvent('def:wishlist:updated', { detail: { handles: favs, action: 'remove' } }));
    return true;
  }

  function toggleFav(handle) {
    handle = normalizeHandle(handle);
    if (!handle) return;

    var favs = getFavs();
    var idx = favs.indexOf(handle);
    var action = 'remove';

    if (idx === -1) {
      favs.push(handle);
      action = 'add';
    } else {
      favs.splice(idx, 1);
    }

    favs = setFavs(favs);
    syncAllButtons(handle);
    updateHeaderCount();

    if (action === 'remove') {
      var page = document.querySelector('[data-wishlist-page]');
      if (page) {
        var item = page.querySelector('[data-wishlist-item="' + handle + '"]');
        if (item) item.remove();
        var grid = page.querySelector('[data-wishlist-grid]');
        var empty = page.querySelector('[data-wishlist-empty]');
        if (grid && !grid.querySelector('[data-wishlist-item]') && empty) {
          empty.hidden = false;
        }
      }
    }

    document.dispatchEvent(
      new CustomEvent('def:wishlist:updated', { detail: { handles: favs, action: action, handle: handle } })
    );
  }

  function initFavButtons(root) {
    (root || document).querySelectorAll('.brand-product-card__fav, .product-form__wishlist, .product-form__wishlist-btn').forEach(function (btn) {
      if (btn.hasAttribute('data-wishlist-remove')) return;
      btn.setAttribute('type', 'button');
      applyFavState(btn);
    });
  }

  function syncAllFavStates() {
    initFavButtons(document);
  }

  function bindFavDelegation() {
    if (document.documentElement.dataset.favDelegation === 'true') return;
    document.documentElement.dataset.favDelegation = 'true';

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.brand-product-card__fav, .product-form__wishlist, .product-form__wishlist-btn');
      if (!btn || btn.hasAttribute('data-wishlist-remove')) return;

      e.preventDefault();
      e.stopPropagation();

      var handle = getBtnHandle(btn);
      if (!handle) return;

      toggleFav(handle);
    });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(
        cents,
        window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}'
      );
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function parseWishlistSectionHtml(html) {
    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    var item = wrapper.querySelector('li[data-wishlist-item], .grid__item[data-wishlist-item]');
    if (item) return item.outerHTML;

    var article = wrapper.querySelector('.brand-product-card[data-product-handle]');
    if (article) {
      var handle = article.getAttribute('data-product-handle');
      return (
        '<li class="grid__item wishlist-page__grid-item" data-wishlist-item="' +
        handle +
        '">' +
        article.outerHTML +
        '</li>'
      );
    }

    return '';
  }

  function fetchProductJson(handle) {
    var root = getStoreRoot();
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
    }).then(function (response) {
      if (!response.ok) throw new Error('Product not found');
      return response.json();
    });
  }

  function getWishlistImage(url) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=720' : url + '?width=720';
  }

  function buildWishlistCard(product) {
    var handle = normalizeHandle(product.handle);
    if (!handle) return '';

    var priceCents = product.price_varies ? product.price_min : product.price;
    var compareCents = product.compare_at_price_min || product.compare_at_price || 0;
    var onSale = compareCents > priceCents;
    var badgeHtml = '';
    if (onSale) {
      var discountPct = Math.round(((compareCents - priceCents) / compareCents) * 100);
      badgeHtml = '<span class="brand-product-card__badge">' + discountPct + '% OFF</span>';
    }

    var compareHtml = onSale
      ? '<s class="brand-product-card__compare">' + formatMoney(compareCents) + '</s>'
      : '';
    var image =
      product.featured_image ||
      (product.images && product.images.length ? product.images[0] : '') ||
      '';
    // Fallback only — section HTML (Liquid) is preferred so ring-builder URLs are correct.
    // Plain product URLs still auto-enter the builder on PDP via collection membership.
    var productUrl = product.url || '/products/' + handle;
    var title = (product.title || '').replace(/"/g, '&quot;');

    return (
      '<li class="grid__item wishlist-page__grid-item" data-wishlist-item="' +
      handle +
      '">' +
      '<article class="brand-product-card" data-product-id="' +
      product.id +
      '" data-product-handle="' +
      handle +
      '">' +
      '<a href="' +
      productUrl +
      '" class="brand-product-card__link">' +
      '<div class="brand-product-card__media">' +
      badgeHtml +
      '<div class="brand-product-card__media-images">' +
      (image
        ? '<img src="' +
          getWishlistImage(image) +
          '" alt="' +
          title +
          '" class="brand-product-card__image brand-product-card__image--primary" loading="lazy" width="533" height="533">'
        : '') +
      '</div></div>' +
      '<div class="brand-product-card__info">' +
      '<h3 class="brand-product-card__title">' +
      (product.title || '') +
      '</h3>' +
      '<div class="brand-product-card__prices">' +
      compareHtml +
      '<span class="brand-product-card__price">' +
      (product.price_varies ? 'from ' : '') +
      formatMoney(priceCents) +
      '</span></div></div></a>' +
      '<button type="button" class="brand-product-card__fav is-fav" data-fav-handle="' +
      handle +
      '" data-fav-id="' +
      product.id +
      '" aria-label="Remove ' +
      title +
      ' from favourites">' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" class="brand-product-card__fav-icon" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
      '</button></article></li>'
    );
  }

  function fetchWishlistCard(handle) {
    var root = getStoreRoot();
    var sectionUrl = root + 'products/' + encodeURIComponent(handle) + '?sections=' + CARD_SECTION;

    return fetch(sectionUrl, { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var html = data && data.sections && data.sections[CARD_SECTION];
        if (html && html.trim()) {
          var parsed = parseWishlistSectionHtml(html);
          if (parsed) return parsed;
        }
        throw new Error('Empty section response');
      })
      .catch(function () {
        return fetchProductJson(handle).then(function (product) {
          return buildWishlistCard(product);
        });
      });
  }

  var wishlistLoadToken = 0;

  function hasWishlistItem(grid, handle) {
    var items = grid.querySelectorAll('[data-wishlist-item]');
    for (var i = 0; i < items.length; i++) {
      if (items[i].getAttribute('data-wishlist-item') === handle) return true;
    }
    return false;
  }

  function loadWishlistPage() {
    var page = document.querySelector('[data-wishlist-page]');
    if (!page) return;

    var grid = page.querySelector('[data-wishlist-grid]');
    var empty = page.querySelector('[data-wishlist-empty]');
    var loading = page.querySelector('[data-wishlist-loading]');
    if (!grid) return;

    var loadToken = ++wishlistLoadToken;
    var favs = getFavs();
    grid.innerHTML = '';

    if (!favs.length) {
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (loading) loading.hidden = false;
    if (empty) empty.hidden = true;

    var completed = 0;
    var successCount = 0;
    var validHandles = [];

    favs.forEach(function (handle) {
      fetchWishlistCard(handle)
        .then(function (html) {
          if (loadToken !== wishlistLoadToken) return;
          if (html && html.trim() && !hasWishlistItem(grid, handle)) {
            grid.insertAdjacentHTML('beforeend', html);
            validHandles.push(handle);
            successCount += 1;
          }
        })
        .catch(function () {})
        .finally(function () {
          completed += 1;
          if (loadToken !== wishlistLoadToken) return;
          if (completed === favs.length) {
            if (loading) loading.hidden = true;

            if (successCount === 0) {
              if (empty) empty.hidden = false;
            } else {
              if (empty) empty.hidden = true;
              initFavButtons(grid);
            }
          }
        });
    });
  }

  function observeDynamicContent() {
    if (!window.MutationObserver) return;
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            initFavButtons(node);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function refreshWishlistUi() {
    updateHeaderCount();
    syncAllFavStates();
    if (document.querySelector('[data-wishlist-page]')) {
      loadWishlistPage();
    }
  }

  function boot(root) {
    migrateLegacyFavs();
    initFavButtons(root);
    updateHeaderCount();
    loadWishlistPage();
  }

  window.DEFWishlist = {
    getFavs: getFavs,
    initFavButtons: initFavButtons,
    syncAllFavStates: syncAllFavStates,
    updateHeaderCount: updateHeaderCount,
    loadWishlistPage: loadWishlistPage,
    toggleFav: toggleFav,
    removeWishlistItem: removeWishlistItem,
    refreshWishlistUi: refreshWishlistUi,
  };

  function start() {
    bindFavDelegation();
    boot();
    observeDynamicContent();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });

  document.addEventListener('product-info:loaded', function (event) {
    initFavButtons(event.target);
    updateHeaderCount();
  });

  document.addEventListener('def:wishlist:updated', function (event) {
    updateHeaderCount();
    syncAllFavStates();

    if (event.detail && event.detail.action === 'remove') return;

    if (document.querySelector('[data-wishlist-page]')) {
      loadWishlistPage();
    }
  });

  window.addEventListener('pageshow', function () {
    refreshWishlistUi();
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      refreshWishlistUi();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== FAV_KEY) return;
    refreshWishlistUi();
  });
})();
